var map = {
	"./date-format.de-CH.json": 969,
	"./date-format.de-DE.json": 970,
	"./date-format.en-CA.json": 971,
	"./date-format.en-GB.json": 972,
	"./date-format.en-IN.json": 973,
	"./date-format.en-ME.json": 974,
	"./date-format.en-US.json": 975,
	"./date-format.es-EM.json": 976,
	"./date-format.es-ES.json": 977,
	"./date-format.fr-BE.json": 978,
	"./date-format.fr-CA.json": 979,
	"./date-format.fr-CH.json": 980,
	"./date-format.nl-BE.json": 981,
	"./date-format.nl-NL.json": 982,
	"./date-format.pl-PL.json": 983,
	"./date-format.pt-BR.json": 984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;